// extracted by mini-css-extract-plugin
export default {"layoutWrapperMain":"ContactUsPage_layoutWrapperMain__yDFu8","contactUs":"ContactUsPage_contactUs__xkPM-","contactLink":"ContactUsPage_contactLink__6nGXr"};